import MobileNavigation from './mobile-navigation';

/**
 * Logic for a Header element
 */
export default class Header {

  /**
   * @property {Element} element This class only controls elements under this element. It's a scope of this class.
   */
  private element:Element;

  /**
   * @property {HeaderDomElements} dom Items referenced in document object model are stored here.
   */
  private dom:HeaderDomElements = {};

  /**
   * @constructor
   * @param {Element} element main element
   */
  constructor(element:Element) {
    this.element = element;
    this.findElements();
    this.attacEventListeners();
  }

  /**
   * Find element from DOM and stores them for a later use.
   * @private
   */
  private findElements() {
    this.dom.languageButton = this.element.querySelector('.language');
    this.dom.secondaryHeader = this.element.querySelector('.secondary-header');
    this.dom.secondaryHeaderNavLists = this.element.querySelectorAll('.navi-list');
    this.dom.langList = this.element.querySelector('ul.navi-list[ng-class="{\'navi-list--open\': activeSecondaryHeader === \'lang-list\'}"]');
    this.dom.searchButton = this.element.querySelector('.search button');
    this.dom.mobileMenuButton = this.element.querySelector('.mobile-controls button.mobile-menu');
    this.dom.mobileSearchButton = this.element.querySelector('.mobile-controls button.search-menu');
    this.dom.languageAndSearch = this.element.querySelector('.language-and-search');
    this.dom.mobileNavigation = this.element.querySelector('.mobile-navigation');
    this.dom.search = this.element.querySelector('.language-and-search .search');
    this.dom.vehoSiteSearchInput = this.element.querySelector('#veho-site-search');
  }

  /**
   * Bind event listeners
   * @private
   */
  private attacEventListeners() {
    this.dom.languageButton.addEventListener('click', this.onLanguageButtonClicked.bind(this));
    this.dom.searchButton.addEventListener('click', this.onSearchButtonClicked.bind(this));
    this.dom.mobileMenuButton.addEventListener('click', this.onMobileMenuButtonClicked.bind(this));
    this.dom.mobileSearchButton.addEventListener('click', this.onMobileSearchButtonClicked.bind(this));
  }

  /**
   * When a search button is clicked
   * @private
   * @param {Event} event event button
   */
  private onSearchButtonClicked(event:Event) {
    const show = !this.dom.search.classList.contains('search--open')
    this.dom.search.classList.toggle('search--open', show);
    if( show ) {
      this.dom.vehoSiteSearchInput.focus();
    }
  }

  /**
   * When a mobile search button is clicked
   * @private
   */
  private onMobileSearchButtonClicked() {
    const show = !this.dom.languageAndSearch.classList.contains('language-and-search--mobile-active');
    this.dom.languageAndSearch.classList.toggle('language-and-search--mobile-active', show);
    this.dom.search.classList.toggle('mobile-active', show);
    MobileNavigation.toggle(false);
  }

  /**
   * Called when a mobile menu button is clicked
   * @private
   */
  private onMobileMenuButtonClicked() {
    this.dom.languageAndSearch.classList.toggle('language-and-search--mobile-active', false);
    this.dom.search.classList.toggle('mobile-active', false);
    MobileNavigation.toggle();
  }

  /**
   * Note: Buttons are currenlty hidden due search page is going to be implement only in one language.
   * Called when a language button is clicked.
   * @private
   */
  private onLanguageButtonClicked() {
    const show = this.dom.secondaryHeader.classList.contains('secondary-header--open');
    this.dom.langList.classList.toggle('navi-list--open', !show);
    this.dom.secondaryHeader.classList.toggle('secondary-header--open', !show);
  }

  /**
   * Initializes and bind logic in to DOM
   * @static
   */
  public static init() {
    document.querySelectorAll('header.header').forEach( element => {
      new Header( element );
    });
  }
}

interface HeaderDomElements {
  languageButton?: HTMLElement;
  secondaryHeader?: HTMLElement;
  secondaryHeaderNavLists?: NodeListOf<HTMLElement>;
  langList?: HTMLElement;
  searchButton?: HTMLElement;
  mobileMenuButton?: HTMLElement;
  mobileSearchButton?: HTMLElement;
  languageAndSearch?: HTMLElement;
  pageHTMLElement?: HTMLElement;
  mobileNavigation?: HTMLElement;
  search?: HTMLElement;
  vehoSiteSearchInput?: HTMLElement;
}

